import { instance } from "../api";

type AccessTransactionPhotoSource = {
  url?: string | null;
  image?: {
    url?: string | null;
    formats?: {
      small?: { url?: string | null } | null;
      thumbnail?: { url?: string | null } | null;
    } | null;
  } | null;
} | null | undefined;

/** Absolute media URL. Strapi rejects `//` in the path as a malicious path. */
export const toAbsoluteMediaUrl = (value?: string | null): string => {
  const url = value?.trim() || "";
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;

  const base = (instance.defaults.baseURL || "").replace(/\/+$/, "");
  return `${base}/${url.replace(/^\/+/, "")}`;
};

/** Prefer media image, then legacy url field. */
export const getAccessTransactionPhotoUrl = (
  photo: AccessTransactionPhotoSource,
): string => {
  const mediaUrl =
    photo?.image?.url?.trim() ||
    photo?.image?.formats?.small?.url?.trim() ||
    photo?.image?.formats?.thumbnail?.url?.trim();
  if (mediaUrl) return toAbsoluteMediaUrl(mediaUrl);

  return toAbsoluteMediaUrl(photo?.url);
};
